export const ROLES_CLAIM = "centro_bp/roles";
export const BROKER_ID_CLAIM = "centro_bp/broker_id";
export const SF_BROKER_ID_CLAIM = "centro_bp/sf_broker_id";

/** The claims read from the merged ID and access tokens. */
export type TokenClaims = {
  readonly sub: string;
  readonly email?: string;
  readonly emails?: readonly string[];
  readonly name?: string;
  readonly given_name?: string;
  readonly family_name?: string;
  readonly [ROLES_CLAIM]?: readonly string[];
  readonly [BROKER_ID_CLAIM]?: string;
  readonly [SF_BROKER_ID_CLAIM]?: string;
};
